import React from "react";

export const NAB_PolicyNewHeader = (props) => {
    return (
        <>
            <thead className={"bp-report-thead"}>
            <tr className={"bp-report-thead-tr"}>
                <th rowSpan={3} className={"bp-report-thead-th"}>Cây báo cáo</th>
                <th colSpan={5} className={"bp-report-thead-th"}>Ngày { props?.inputDay }</th>
                <th colSpan={13} className={"bp-report-thead-th"}>MTD</th>
                <th colSpan={2} className={"bp-report-thead-th"}>YTD</th>
            </tr>
            <tr className={"bp-report-thead-tr"}>
                <th colSpan={1}>Đầu mối</th>
                <th colSpan={2}>Nộp</th>
                <th colSpan={2}>Phát hành</th>
                <th colSpan={3}>Đầu mối</th>
                <th colSpan={2}>Nộp</th>
                <th colSpan={2}>Phát hành</th>
                <th colSpan={2}>Tình trạng chờ</th>
                <th colSpan={2}>Hủy & Từ chối</th>
                <th colSpan={2}>Hủy trong 21 ngày</th>
                <th colSpan={2}>Phát hành</th>
            </tr>
            <tr className={"bp-report-thead-tr"}>
                <th>Giới thiệu</th>
                <th>Chốt HĐ</th>
                <th>IP</th>
                <th>Hợp đồng</th>
                <th>IP</th>
                <th>Giới thiệu</th>
                <th>Gặp khách hàng</th>
                <th>Tư vấn sâu</th>
                <th>Chốt HĐ</th>
                <th>IP</th>
                <th>Hợp đồng</th>
                <th>IP</th>
                <th>Hợp đồng</th>
                <th>IP</th>
                <th>Hợp đồng</th>
                <th>IP</th>
                <th>Hợp đồng</th>
                <th>IP</th>
                <th>Hợp đồng</th>
                <th>IP</th>
            </tr>
            </thead>
        </>
    )
}

export default  NAB_PolicyNewHeader;